import Vue from 'vue'
import http from '@/services/http.service'

const development = process.env.NODE_ENV === 'development'

const storage = development ? sessionStorage : localStorage

const ANNOUNCEMENT_LAST_READ_KEY = development
  ? 'DEV_BIZOO_ANNOUNCEMENT_LAST_READ'
  : 'BIZOO_ANNOUNCEMENT_LAST_READ'

// 各コンポーネントからアクセスするときの名前登録（テンプレ）
Vue.mixin({
  beforeCreate() {
    const options = this.$options
    if (options.dialog) this.$announcement = options.announcement
    else if (options.parent && options.parent.$announcement)
      this.$announcement = options.parent.$announcement
  },
})

export default {
  /**
   * 取得
   */
  async get() {
    const response = await http.get(`/announcements`)
    return response.data
  },
  getLastRead() {
    return Promise.resolve(storage.getItem(ANNOUNCEMENT_LAST_READ_KEY))
  },
  postLastRead(id) {
    storage.setItem(ANNOUNCEMENT_LAST_READ_KEY, id)
    return Promise.resolve()
  },
}
